import React, { useEffect, createElement } from 'react';
interface VidalyticsVideoProps {
  embedId: string;
  aspectRatio?: string;
}
export const VidalyticsVideo = ({
  embedId,
  aspectRatio = '56.25%'
}: VidalyticsVideoProps) => {
  useEffect(() => {
    // Create a function that mimics the IIFE from the Vidalytics embed code
    const loadVidalytics = () => {
      const v = window;
      const i = document;
      const d = 'Vidalytics';
      const l = 'https://fast.vidalytics.com/embeds/4FbV_O2r/' + embedId + '/';
      const y = '_' + d.toLowerCase();
      const c = d + 'L';
      // Set up the global objects if they don't exist
      if (!v[d]) v[d] = {};
      if (!v[c]) v[c] = {};
      if (!v[y]) v[y] = {};
      const vl = 'Loader';
      const vli = v[y][vl];
      const vsl = v[c][vl + 'Script'];
      const ve = 'Embed';
      // Create script loader function if it doesn't exist
      if (!vsl) {
        v[c][vl + 'Script'] = function (u, cb) {
          const s = i.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = u;
          if (s.readyState) {
            s.onreadystatechange = function () {
              if (s.readyState === 'loaded' || s.readyState === 'complete') {
                s.onreadystatechange = null;
                v[c][vl + 'Loaded'] = 1;
                cb();
              }
            };
          } else {
            s.onload = function () {
              v[c][vl + 'Loaded'] = 1;
              cb();
            };
          }
          i.getElementsByTagName('head')[0].appendChild(s);
        };
      }
      // Load the scripts
      const loadScript = v[c][vl + 'Script'] || vsl;
      loadScript(l + 'loader.min.js', function () {
        if (!vli) {
          const vlc = v[c][vl];
          if (vlc) {
            const newLoader = new vlc();
            v[y][vl] = newLoader;
            newLoader.loadScript(l + 'player.min.js', function () {
              const vec = v[d][ve];
              if (vec) {
                const player = new vec();
                player.run('vidalytics_embed_' + embedId);
              }
            });
          }
        }
      });
    };
    // Run the function to load Vidalytics
    loadVidalytics();
    // Cleanup function
    return () => {
      // Remove any scripts created by Vidalytics
      const scripts = document.querySelectorAll('script[src*="vidalytics.com"]');
      scripts.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      // Remove any elements created by Vidalytics
      const elements = document.querySelectorAll(`[id^="vidalytics_"]`);
      elements.forEach(el => {
        if (el.id !== `vidalytics_embed_${embedId}`) {
          el.remove();
        }
      });
      // Clean up global variables
      if (window['Vidalytics']) delete window['Vidalytics'];
      if (window['VidalyticsL']) delete window['VidalyticsL'];
      if (window['_vidalytics']) delete window['_vidalytics'];
    };
  }, [embedId]);
  return <div id={`vidalytics_embed_${embedId}`} className="w-full relative" style={{
    paddingTop: aspectRatio
  }} data-id="element-389" />;
};